import {
    AUTH_GOOGLE_ACTION,
    AUTH_GOOGLE_WITH_CODE_ACTION,
    AUTH_ERROR_ACTION,
    NOTIFIED_ACTION
} from './constants';

export const authGoogle = () => ({
    type: AUTH_GOOGLE_ACTION
});

export const authGoogleWithCode = (code: string | string[] | null | undefined) => ({
    type: AUTH_GOOGLE_WITH_CODE_ACTION,
    code
});

export const authError = () => ({
    type: AUTH_ERROR_ACTION
});

export const notified = () => ({
    type: NOTIFIED_ACTION
});
